@if (!model.draft) {
  <fui-rows [label]="'Plan Management'">
    <fui-content-layout-header-control slot="after">
      @if (!editing && model.canEdit()) {
        <fui-link-button [title]="'edit'"
        (click)="edit()"></fui-link-button>
      }
    </fui-content-layout-header-control>
    @if (data && model && model.data) {
      @if (!UserData.isSalesRep(loggedUser)) {
        <fui-row>
          <fui-two-columns>
            <fui-column>
              <fui-select-control [options]="preferredFeeModeOptions"
                [allowClearSelectionOption]="false"
                (valueChange)="changeFeeCalculation($event)"
                [value]="getSelectedFeeCalculation()"
                [labelField]="'label'"
                [label]="'Preferred Fee Calculation Mode'"
                [disabled]="!editing && !model.newVenue"
                [placeholder]="''"
                [loading]="false"
                [valueField]="'value'">
              </fui-select-control>
            </fui-column>
          </fui-two-columns>
        </fui-row>
      }
      @if (!model.draft && !UserData.isSalesRep(loggedUser)) {
        <fui-row>
          <fui-two-columns>
            <fui-column>
              <fui-numeric-control [label]="'fhm.venue-plan.skipBillingCycles'"
                [placeholder]="' '"
                [disabled]="!editing && !model.newVenue"
                [decimals]="0"
                [ngModelOptions]="{standalone: true}"
              [(ngModel)]="data.skipBillingCycles"></fui-numeric-control>
            </fui-column>
            <fui-column>
              <fui-text-control [label]="'fhm.venue-plan.skipBillingCyclesReason'"
                [placeholder]="' '"
                [disabled]="!editing && !model.newVenue"
                [ngModelOptions]="{standalone: true}"
              [(ngModel)]="data.skipBillingCyclesReason"></fui-text-control>
            </fui-column>
          </fui-two-columns>
        </fui-row>
      }
      @if (useTieredPricing) {
        <fui-row>
          <fui-two-columns>
            <fui-column>
              <fui-tandem-field>
                <fui-numeric-control [label]="'Current Tier'"
                  [placeholder]="' '"
                  [disabled]="(!editing && !model.newVenue)"
                  [decimals]="0"
                  [ngModelOptions]="{standalone: true}"
                [(ngModel)]="data.currentTier"></fui-numeric-control>
                <fui-date-control [label]="'Lock Tier Until'"
                  [(ngModel)]="lockTierUntilDate"
                  [ngModelOptions]="{standalone: true}"
                  [disabled]="!editing"
                (valueChange)="changeLockTierUntilDate($event)"></fui-date-control>
              </fui-tandem-field>
            </fui-column>
            <fui-column>
              @if (data.lockTierUntilDate) {
                <fui-inline-warning [title]="'Tier Locked'" [message]="'Tier is locked until the end of the billing cycle after the locked date'"></fui-inline-warning>
              }
            </fui-column>
          </fui-two-columns>
        </fui-row>
      }
      @if (editing && !model.draft) {
        <fui-row>
          <fhm-action-buttons>
            @if (data) {
              <fhm-remove-button [title]="'fhm.common.button.cancel'"
              (clicked)="cancelEdit()"></fhm-remove-button>
            }
            <fhm-provision-button
              [title]="data ? 'fhm.common.button.save' : 'fhm.common.button.create'"
            (clicked)="save()"></fhm-provision-button>
          </fhm-action-buttons>
        </fui-row>
      }
    }
  </fui-rows>
}
